<div mat-dialog-title>
  <h3>{{ title }}</h3>
  <button
    [mat-dialog-close]="false"
    matIconButton
    class="close-btn">
    <mat-icon>close</mat-icon>
  </button>
</div>

<div mat-dialog-content>
  <table
    mat-table
    [dataSource]="dataSource"
    class="w-100 first-cell cells-padded row-h-40">
    <!-- Checkbox Column -->
    <ng-container matColumnDef="select">
      <th
        mat-header-cell
        *matHeaderCellDef>
        &nbsp;
      </th>
      <td
        mat-cell
        *matCellDef="let row; let i = index">
        <mat-checkbox
          (click)="$event.stopPropagation()"
          (change)="$event ? selection.toggle(row) : null"
          [checked]="selection.isSelected(row)"
          [aria-label]="checkboxLabel(row)"></mat-checkbox>
      </td>
    </ng-container>

    <!-- LEI Column -->
    <ng-container matColumnDef="lei">
      <th
        mat-header-cell
        *matHeaderCellDef>
        LEI
      </th>
      <td
        mat-cell
        *matCellDef="let element">
        <span
          class="lei-link"
          [floatUi]="leiDetails"
          [showTrigger]="popTriggers.click"
          [appendTo]="'body'"
          [applyClass]="'lei-details-popover'">
          {{ getLei(element) }}
        </span>
        <float-ui-content #leiDetails>
          <ume-lei-details [leiProfile]="element"></ume-lei-details>
        </float-ui-content>
      </td>
    </ng-container>

    <!-- Legal Name Column -->
    <ng-container matColumnDef="legalName">
      <th
        mat-header-cell
        *matHeaderCellDef>
        Legal Name
      </th>
      <td
        mat-cell
        *matCellDef="let element">
        <span>{{ getName(element) }}</span>
      </td>
    </ng-container>

    <!-- Status Column -->
    <ng-container matColumnDef="status">
      <th
        mat-header-cell
        *matHeaderCellDef>
        Status
      </th>
      <td
        mat-cell
        *matCellDef="let element">
        <span>{{ getStatus(element) }}</span>
      </td>
    </ng-container>

    <tr
      mat-header-row
      *matHeaderRowDef="displayedColumns; sticky: true"></tr>
    <tr
      mat-row
      *matRowDef="let row; columns: displayedColumns"
      (click)="selection.toggle(row)"></tr>
  </table>
</div>

<div
  mat-dialog-actions
  align="end">
  <button
    matButton="outlined"
    class="primary-button"
    [disabled]="!selectedProfile"
    (click)="makeSelection()">
    Ok
  </button>
</div>
